import { iconSizeOptions } from '../icons/icons-sizes'

const statusIndicationMemberOptions = {
  NO_STATUS: 'no-status',
  INVITED: 'invited',
  ACTIVE: 'active',
  UNLICENSED: 'unlicensed',
  INACTIVE: 'inactive'
}

const statusIndicationMemberVariantOptions = {
  MEMBER: 'member',
  TEAM: 'team',
  CONTACT: 'contact'
}

const statusIndicationSizeOptions = {
  [iconSizeOptions['ICON-S']]: {
    width: '5px',
    height: '5px',
    '.status-indicator': {
      width: '4px',
      height: '4px'
    }
  },
  [iconSizeOptions['ICON-M']]: {
    width: '7.5px',
    height: '7.5px',
    '.status-indicator': {
      width: '6px',
      height: '6px'
    }
  },
  [iconSizeOptions['ICON-L']]: {
    width: '10px',
    height: '10px',
    '.status-indicator': {
      width: '8px',
      height: '8px'
    }
  },
  [iconSizeOptions['ICON-XL']]: {
    width: '16px',
    height: '16px',
    '.status-indicator': {
      width: '12px',
      height: '12px'
    }
  }
}

export {
  statusIndicationMemberOptions,
  statusIndicationMemberVariantOptions,
  statusIndicationSizeOptions
}
